// 통신사별 서비스 노출명.
//
// LGU+ 는 제휴 조건상 "휴대폰분실피해방지" 로 노출해야 하고, SKT 는 자사 브랜드인 "폰지킴" 을 쓴다.
// KT 는 미서비스(준비중) 이므로 선택될 수 없고, 통신사가 정해지지 않은 경우와 함께 기본값으로 둔다.
const SERVICE_NAMES = {
  SKT: "폰지킴",
  LGUP: "휴대폰분실피해방지",
};

/**
 * 통신사를 모를 때 쓰는 서비스명.
 *
 * ※ 앱 헤더도 이 값을 쓴다. 로그인 정보에 통신사가 없어 SKT 가입자에게도 이 이름이 보인다.
 *   통신사를 내려받게 되면 헤더에서 useServiceName 으로 바꿔야 한다.
 */
export const DEFAULT_SERVICE_NAME = "휴대폰분실피해방지";

/** 통신사를 지정하지 않고 들어왔을 때 쓰는 기본 통신사 */
export const DEFAULT_TELCO = "LGUP";

/**
 * URL 경로로 통신사를 지정해 들어올 수 있다. (/bye/skt, /refund/lgu)
 * 제휴사별 랜딩에서 해당 통신사가 선택된 상태로 열리게 하기 위한 것이다.
 *
 * ※ KT 는 아직 준비중이라 기본 통신사로 돌린다. KT 오픈 시 kt 를 "KT" 로 바꾸고
 *   bye / refund 의 handleCarrierClick 에 있는 KT 차단도 함께 풀어야 한다.
 */
const TELCO_BY_SLUG = {
  skt: "SKT",
  lgu: "LGUP",
  lgup: "LGUP",
  kt: DEFAULT_TELCO,
};

/** URL 슬러그를 내부 통신사 코드로 바꾼다. 모르는 값이면 기본값으로 떨어진다. */
export const telcoFromSlug = (slug) => TELCO_BY_SLUG[String(slug || "").toLowerCase()] || DEFAULT_TELCO;

/** 통신사 코드로 서비스명 문자열을 얻는다. (ref/computed 가 아닌 평문이 필요할 때) */
export const serviceNameOf = (telco) => SERVICE_NAMES[String(telco || "").toUpperCase()] || DEFAULT_SERVICE_NAME;

/**
 * 통신사에 맞는 서비스명을 computed 로 돌려준다.
 *
 * @param telco 통신사 코드. ref / computed / getter / 문자열 모두 받는다.
 */
export const useServiceName = (telco) => {
  return computed(() => serviceNameOf(typeof telco === "function" ? telco() : unref(telco)));
};
